/**
 * パスワード付きURLでの入店対応。
 * /password#pw=xxx（推奨。フラグメントはサーバーログに残らない）または
 * /password?pw=xxx でアクセスすると、非表示のパスワードフォームへ値を入れて自動送信する。
 * `password` キーもエイリアスとして受け付ける。
 * 送信済みでエラーが出ている場合（パスワード誤り）は再送信せず、エラー表示のままにする。
 */
(function () {
  var input = document.querySelector('[data-password-input]');
  var errorEl = document.querySelector('[data-password-error]');

  if (!input || !input.form) return;
  if (errorEl) return;

  var passphrase = null;

  if (location.hash.indexOf('#pw=') === 0) {
    passphrase = decodeURIComponent(location.hash.slice(4));
  } else if (location.hash.indexOf('#password=') === 0) {
    passphrase = decodeURIComponent(location.hash.slice(10));
  } else {
    var params = new URLSearchParams(location.search);
    passphrase = params.get('pw') || params.get('password');
  }

  if (!passphrase) return;

  input.value = passphrase;
  input.form.submit();
})();
